export default __webpack_public_path__ + "assets/108861ddf374359c34730b54fe550c1d.jpeg";